var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-layout-container"},[_c('div',{staticClass:"print-top-bar"},[_vm._t("top")],2),_vm._v(" "),_c('div',{staticClass:"print-body-container"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }